import { InteractiveContainer, PlainButton } from "@jugl-web/ui-kit";
import React, { PropsWithChildren } from "react";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";

export const AgentKnowledgeItemContainer: React.FC<
  PropsWithChildren<{
    icon: React.ReactNode;
    title: string;
    onDelete?: () => void;
    onClick: () => void;
  }>
> = ({ icon, title, onDelete, onClick, children }) => (
  <InteractiveContainer
    className="flex items-start justify-between gap-2.5 rounded-2xl border border-solid border-grey-400 p-5"
    onClick={onClick}
  >
    <div className="flex flex-col gap-1.5 overflow-hidden">
      <div className="flex items-center gap-1.5">
        <div className="flex shrink-0 items-center justify-center">{icon}</div>
        <span className="truncate font-secondary leading-4 font-semibold text-dark">
          {title}
        </span>
      </div>
      <div className="jugl__break-word line-clamp-5 max-w-[700px] font-secondary text-sm text-dark-700">
        {children}
      </div>
    </div>
    {onDelete && (
      <PlainButton
        className="flex shrink-0 items-center justify-center p-1.5"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <TrashIcon />
      </PlainButton>
    )}
  </InteractiveContainer>
);
